<template>
	<transition name="cover" mode="out-in" @after-enter="readyUp" v-if="image">
		<v-responsive ref="cover" :aspect-ratio="4 / 2.75" class="cover" :class="{ 'cover--in': isReady && isLoaded }">
			<img class="cover__image" :src="image.Src" :alt="image.Alt" @load="isLoaded = true" loading="lazy" />
		</v-responsive>
	</transition>

	<!-- Image placeholder while image is being loaded to prevent layout shifting. See: https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/#layout_shifting_and_placeholders -->
	<v-responsive v-else :aspect-ratio="4 / 2.75" />
</template>

<script>
export default {
	name: 'cover-image',
	data() {
		return {
			image: null,
			isLoaded: false,
			isReady: false
		};
	},
	methods: {
		readyUp() {
			this.$nextTick(() => {
				setTimeout(() => {
					requestAnimationFrame(() => {
						this.isReady = true;
						setTimeout(() => {
							// Smooth out edges. Applying after transitions to prevent image tearing.
							this.$refs.cover.$el.style['-webkit-backface-visibility'] = 'hidden';
						}, 250);
					});
				}, 250);
			});
		}
	},
	async beforeCreate() {
		this.image = await this.$umbraco.GetCoverImage();
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.cover {
	--skew: 13deg;
	--skew-negative: -13deg; /* IE/Edge not handling calc() in transforms */
	position: relative;
	transform: skewY(var(--skew-negative));
	max-height: 100%;

	@media #{map-get($display-breakpoints, 'sm-and-up')} {
		max-width: 50vw;
	}

	&::v-deep .v-responsive__content {
		display: flex;
		align-items: center;
	}

	&::after {
		content: '';
		background-color: var(--v-primary-base);
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		transition: width ease-in-out 250ms;
	}

	&--in {
		&::after {
			left: unset;
			width: 0%;
		}

		.cover__image {
			opacity: 1;
		}
	}

	&__image {
		object-fit: cover;
		min-width: 1px;
		width: 100%;
		transform: scale(1.535) skewY(var(--skew)); /* scale of 1.535 to compansate cut-off edges for the skewed box */
		opacity: 0;
	}

	&-enter {
		&::after {
			width: 0%;
		}
	}
}
</style>
